import React, { useState } from "react";
import { Box, Typography, Snackbar, Alert } from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router";
import BackArrowIcon from "@assets/icons/backArrowIcon";
import UpdateUserProfile from "./components/updateUserProfile";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "@store/store";
import { clearLoadingState } from "@store/addUserSlice";
import { verifyUser } from "@store/userSlice";
const UserProfile: React.FC = () => {
  const { updateUserloading, updateUserError } = useSelector(
    (state: any) => state.addUser
  );
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [showLoader, setShowLoader] = useState(false);
  const handleBackClick = () => {
    navigate("/?status=active");
  };

  const handleAlertClose = () => {
    dispatch(clearLoadingState());
    setShowLoader(false);
    if (!updateUserloading && !updateUserError) {
      dispatch(verifyUser());
    }
  };

  return (
    <Box className="px-4 md:px-8 pt-6" sx={{ height: "calc(100vh - 120px)" }}>
      <Box className="flex pb-4 justify-between ">
        <Box className="flex items-center">
          <Box
            className="flex items-center cursor-pointer"
            onClick={handleBackClick}
          >
            <Typography>
              <BackArrowIcon />
            </Typography>
            <Typography
              component="div"
              sx={{ color: "#318FE0", paddingLeft: "0.5rem" }}
            >
              Dashboard
            </Typography>
          </Box>
          <ArrowRightIcon />
          <Typography component="div" sx={{ mr: "auto" }}>
            User Profile
          </Typography>
        </Box>
      </Box>
      <Box>
        <UpdateUserProfile setShowLoader={setShowLoader} showLoader={showLoader} />
      </Box>
      <Snackbar
        className="!pt-[8rem] md:!pt-14"
        open={!updateUserloading || updateUserError}
        autoHideDuration={3000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {!updateUserError && !updateUserloading ? (
          <Alert variant="filled" severity="success" icon={false} sx={{
            bgcolor:  "#318FE0",
            color: '#fff'
          }}>
            Updated Successfully
          </Alert>
        ) : (
          <Alert variant="filled" severity="error">
            {updateUserError}
          </Alert>
        )}
      </Snackbar>
    </Box>
  );
};
export default UserProfile;
